import { Notice } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

export const SyncFailedMessage: FunctionComponent = () => (
  <Notice
    css={(theme) => ({ flexGrow: 0, margin: theme.spacing([4, 0]) })}
    title="Failed to load property data"
    type="error"
  >
    We were unable to load the property data. This may be due to a temporary network issue. Please
    try refreshing the page. If the problem persists, please contact IT support.
  </Notice>
);
